<!-- place holder label for field alignment  -->
<label *ngIf="lmColumnLayoutInfo?.nbrColumns > 1 || lmParagraphLayoutInfo?.hasVisibleLabels">&nbsp;</label>
<ng-container>
  <ng-container [ngSwitch]="displayType">
    <ng-container *ngSwitchCase="layoutDisplayType.STAR">
      <button
        [attr.id]="id"
        soho-button="favorite"
        (click)="onClickEvent($event)"
        (fieldEvent)="onFieldEvent($event)"
        [attr.readOnly]="hasCheckedState"
        [state]="modelField.value"
        (focusout)="onFieldBlur($event)"
      ></button>
      <label
        soho-label
        [required]="isRequired"
        [forCheckBox]="true"
        [attr.for]="id"
        lm-label
          [layoutField]="field"
          [personalize]="personalize"
        lm-text-style [textStyle]="field?.label?.textStyle"
        class="lm-checkbox-label"
      >{{triggerValue| formatLabelRule:field:labelResourceValue:model:specFields}}<ng-container *ngTemplateOutlet="mouseOverTextTemplate"></ng-container>
      </label>
    </ng-container>
    <ng-container *ngSwitchCase="layoutDisplayType.BOX">
      <input
        [ngClass]="fieldClassesString"
        type="checkbox"
        soho-checkbox
        [attr.id]="id"
        [attr.bindId]="bindId"
        [attr.readOnly]="hasCheckedState"
        [attr.disabled]="hasCheckedState"
        [(ngModel)]="modelField.value"
        (click)="onClickEvent($event)"
        (fieldEvent)="onFieldEvent($event)"
        (focusout)="onFieldBlur($event)"
      />
      <label
        soho-label
        [required]="isRequired"
        [forCheckBox]="true"
        [attr.for]="id"
        lm-label
          [layoutField]="field"
          [personalize]="personalize"
        lm-text-style [textStyle]="field?.label?.textStyle"
        class="lm-checkbox-label"
      >{{triggerValue| formatLabelRule:field:labelResourceValue:model:specFields}}<ng-container *ngTemplateOutlet="mouseOverTextTemplate"></ng-container>
      </label>
    </ng-container>
    <ng-container *ngSwitchCase="layoutDisplayType.SWITCH">
      <div class="switch"
        soho-tooltip content="{{triggerValue | booleanAsSwitchTooltip:modelField.value:false}}"
        [ngStyle]="{'display': 'inline-block'}"
      >
        <input
          [ngClass]="fieldClassesString"
          type="checkbox"
          [attr.id]="id"
          [attr.bindId]="bindId"
          [attr.readOnly]="hasCheckedState"
          [attr.disabled]="hasCheckedState"
          [(ngModel)]="modelField.value"
          (click)="onClickEvent($event)"
          (fieldEvent)="onFieldEvent($event)"
          (focusout)="onFieldBlur($event)"
        />
        <label
          soho-label
          [required]="isRequired"
          [attr.for]="id"
          lm-label
            [layoutField] = "field"
            [personalize]="personalize"
          lm-text-style [textStyle]="field?.label?.textStyle"
          class="lm-checkbox-label"
        >{{triggerValue| formatLabelRule:field:labelResourceValue:model:specFields}}<ng-container *ngTemplateOutlet="mouseOverTextTemplate"></ng-container>
        </label>
      </div>
    </ng-container>
  </ng-container>
</ng-container>

<ng-template #mouseOverTextTemplate>
  <ng-container *ngIf="layoutObject.mouseOverText">
    <lm-mouse-over-text
        [beforeShowTooltip]="displayMouseOverText"
    ></lm-mouse-over-text>
  </ng-container>
</ng-template>
